import type * as Types from '../../../../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetQuickSearchSuggestionsQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String']['input'];
}>;


export type GetQuickSearchSuggestionsQuery = { search: { globalSearch: { searchTerm: string | null, categories: Array<{ totalItemCount: number | null, categoryType: string | null, categoryName: string | null, subTypeId: number | null, items: Array<{ id: number | null, name: string | null, description: string | null, type: string | null, subTypeId: number | null } | null> | null } | null> | null } | null } };


export const GetQuickSearchSuggestionsDocument = gql`
    query getQuickSearchSuggestions($searchTerm: String!) {
  search {
    globalSearch(searchTerm: $searchTerm) {
      searchTerm
      categories {
        totalItemCount
        categoryType
        categoryName
        subTypeId
        items {
          id
          name
          description
          type
          subTypeId
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuickSearchSuggestionsQuery__
 *
 * To run a query within a React component, call `useGetQuickSearchSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickSearchSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickSearchSuggestionsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function useGetQuickSearchSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<GetQuickSearchSuggestionsQuery, GetQuickSearchSuggestionsQueryVariables> & ({ variables: GetQuickSearchSuggestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickSearchSuggestionsQuery, GetQuickSearchSuggestionsQueryVariables>(GetQuickSearchSuggestionsDocument, options);
      }
export function useGetQuickSearchSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickSearchSuggestionsQuery, GetQuickSearchSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickSearchSuggestionsQuery, GetQuickSearchSuggestionsQueryVariables>(GetQuickSearchSuggestionsDocument, options);
        }
export function useGetQuickSearchSuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickSearchSuggestionsQuery, GetQuickSearchSuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickSearchSuggestionsQuery, GetQuickSearchSuggestionsQueryVariables>(GetQuickSearchSuggestionsDocument, options);
        }
export type GetQuickSearchSuggestionsQueryHookResult = ReturnType<typeof useGetQuickSearchSuggestionsQuery>;
export type GetQuickSearchSuggestionsLazyQueryHookResult = ReturnType<typeof useGetQuickSearchSuggestionsLazyQuery>;
export type GetQuickSearchSuggestionsSuspenseQueryHookResult = ReturnType<typeof useGetQuickSearchSuggestionsSuspenseQuery>;
export type GetQuickSearchSuggestionsQueryResult = Apollo.QueryResult<GetQuickSearchSuggestionsQuery, GetQuickSearchSuggestionsQueryVariables>;